import { useState, useEffect, useCallback } from "react";
import { FiPlus, FiSearch, FiMoreHorizontal } from "react-icons/fi";
import Notification from "../components/Notification";
import { getAllBranch } from "../api/reusableApis";
import axios from "axios";
import Popover from "../components/ui/Popover";

export default function Branch() {
  const [branches, setBranches] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(true);
  // const [openMenuId, setOpenMenuId] = useState(null);
  const [toast, setToast] = useState({ message: "", type: "success" });
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  // Modal states
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  // const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });


  // Current branch for view/edit
  const [currentBranch, setCurrentBranch] = useState(null);

  // Form state for add/edit
  const [form, setForm] = useState({});
  const headers_obj = {
    headers: {
      'ZCFKEY': apiKey
    }
  }
  const fetchBranch = useCallback(async () => {
    try {
      setLoader(true);
      const res = await getAllBranch();
      setBranches(res || []);
    } catch (err) {
      setToast({ message: "Failed to load branches", type: "error" });
    } finally {
      setLoader(false);
    }
  }, []);

  useEffect(() => {
    fetchBranch();
  }, [fetchBranch]);

  const filteredBranch = branches.filter((b) => {
    const q = search.toLowerCase();
    return (
      (b.Branch_Name || "").toLowerCase().includes(q) ||
      (b.city || "").toLowerCase().includes(q) ||
      (b.state || "").toLowerCase().includes(q) ||
      (b.country || "").toLowerCase().includes(q) ||
      (b.pincode || "").toLowerCase().includes(q) ||
      (b.phone || "").toLowerCase().includes(q)
    );
  });

  const handleView = (branch) => {
    setCurrentBranch(branch);
    setIsViewOpen(true);
    // setOpenMenuId(null);
  };


  const handleEdit = (branch) => {
    setCurrentBranch(branch);
    setForm({
      Branch_Name: branch.Branch_Name || "",
      address1: branch.address1 || "",
      address2: branch.address2 || "",
      landmark: branch.landmark || "",
      city: branch.city || "",
      state: branch.state || "",
      country: branch.country || "",
      pincode: branch.pincode || "",
      phone: branch.phone || "",
      is_active: branch.is_active || false,
      logo: branch.logo || null,
      ROWID: branch.ROWID || null,
    });
    setIsEditOpen(true);
    // setOpenMenuId(null);
  };


  const handleAdd = () => {
    setForm({
      Branch_Name: "",
      address1: "",
      address2: "",
      landmark: "",
      city: "",
      state: "",
      country: "india",
      pincode: "",
      phone: "",
      is_active: true,
      image: null,
      logo: null,
    });
    setIsAddOpen(true);
  };





  return (
    <>
      {/* ---------- Notification ---------- */}
      <Notification
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ message: "", type: "success" })}
      />

      {/* ---------- Loader ---------- */}
      {loader ? (
        <div className="flex items-center justify-center min-h-[60vh] w-full">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-[#22C55E] rounded-full animate-spin" />
        </div>
      ) : (
        <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen">

          {/* ---------- Header ---------- */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
            <div>
              <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Branches</h1>
              <p className="text-sm text-slate-500">Add a short description of this branch, its location, facilities, and any special offerings.</p>
            </div>

            <button
              onClick={handleAdd}
              className="flex items-center gap-2 text-white px-5 py-2 rounded-xl shadow-md transition bg-[#72398E]"
            >
              <FiPlus /> Add Branch
            </button>
          </div>

          {/* ---------- Filter Bar ---------- */}
          <div className="bg-white rounded-xl shadow-md border border-slate-200 p-4 flex flex-col sm:flex-row gap-4 mb-6">
            <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-4 py-2 flex-1 bg-slate-50 focus-within:ring-2 focus-within:ring-slate-900">
              <FiSearch className="text-slate-400" />
              <input
                placeholder="Search branch, city, phone"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="bg-transparent outline-none text-sm w-full"
              />
            </div>
          </div>

          {/* ---------- Desktop Table ---------- */}
          <div className="hidden md:block bg-white rounded-xl shadow-lg overflow-hidden max-h-[60vh] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-100 text-slate-500 uppercase text-xs tracking-wider">
                <tr>
                  <th className="p-4 text-left">Branch</th>
                  <th className="text-center">City</th>
                  <th className="text-center">State</th>
                  <th className="text-center">Country</th>
                  <th className="text-center">Pincode</th>
                  <th className="text-center">Phone</th>
                  <th className="text-center">Status</th>
                  <th className="text-right pr-6">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {filteredBranch.map((b) => (
                  <tr key={b.ROWID} className="hover:bg-slate-50 transition">
                    <td className="flex items-center gap-3 p-4">
                      <img
                        src={b.logo || "/placeholder.png"}
                        alt="img"
                        className="w-10 h-10 rounded-xl ring-2 ring-white shadow"
                      />
                      <div>
                        <p className="font-semibold">{b.Branch_Name}</p>
                        <p className="text-xs text-slate-500 truncate max-w-[220px]">
                          {b.address1 || "—"}
                        </p>
                      </div>
                    </td>
                    <td className="text-center text-slate-600">{b.city || "—"}</td>
                    <td className="text-center text-slate-600">{b.state || "—"}</td>
                    <td className="text-center text-slate-600">{b.country || "—"}</td>
                    <td className="text-center text-slate-600">{b.pincode || "—"}</td>
                    <td className="text-center text-slate-600">{b.phone || "—"}</td>
                    <td className="text-center">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${b.is_active ? "bg-purple-100 text-purple-700" : "bg-rose-100 text-rose-600"
                          }`}
                      >
                        {b.is_active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="pr-6 relative">
                      <div className="flex justify-center pl-10">
                        <Popover
                          placement="bottom-end"
                          trigger={
                            <FiMoreHorizontal className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-800" />
                          }
                        >
                          <button
                            onClick={() => handleView(b)}
                            className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100"
                          >
                            View
                          </button>

                          <button
                            onClick={() => handleEdit(b)}
                            className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100"
                          >
                            Edit
                          </button>

                          <button
                            onClick={() => {
                              setToast({
                                message: b.is_active
                                  ? "Branch deactivated (mock)"
                                  : "Branch activated (mock)",
                                type: "success",
                              });

                              setBranches((prev) =>
                                prev.map((item) =>
                                  item.ROWID === b.ROWID
                                    ? { ...item, is_active: !item.is_active }
                                    : item
                                )
                              );
                            }}
                            className={`w-full px-4 py-2 text-left text-sm ${b.is_active
                              ? "text-rose-600 hover:bg-rose-50"
                              : "text-purple-600 hover:bg-purple-50"
                              }`}
                          >
                            {b.is_active ? "Deactivate" : "Activate"}
                          </button>
                        </Popover>
                      </div>

                    </td>
                  </tr>
                ))}
                {filteredBranch.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center py-10 text-slate-400">
                      No branches found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ---------- Mobile Branch Cards ---------- */}
          <div className="md:hidden space-y-4">
            {filteredBranch.length === 0 ? (
              <div className="text-center text-slate-400 py-10">
                No branches found
              </div>
            ) : (
              filteredBranch.map((b) => (
                <div
                  key={b.ROWID}
                  className="bg-white rounded-2xl p-4 shadow-sm hover:shadow-md border border-slate-200 transition"
                >
                  {/* Top Row: Logo + Branch Name */}
                  <div className="flex items-center gap-4">
                    <img
                      src={b.logo || "/placeholder.png"}
                      alt={b.Branch_Name}
                      className="w-16 h-16 rounded-xl ring-1 ring-gray-200 shadow-sm object-cover"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-lg font-semibold text-slate-900 truncate">
                        {b.Branch_Name}
                      </p>
                      <p className="text-sm text-slate-500 truncate">
                        {b.address1 || "—"}
                      </p>
                    </div>
                    <Popover
                      placement="bottom-end"
                      trigger={
                        <FiMoreHorizontal className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-800" />
                      }
                    >
                      <button
                        onClick={() => handleView(b)}
                        className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100"
                      >
                        View
                      </button>

                      <button
                        onClick={() => handleEdit(b)}
                        className="w-full px-4 py-2 text-left text-sm hover:bg-slate-100"
                      >
                        Edit
                      </button>

                      {/* <button
                        onClick={() => {
                          setToast({
                            message: b.is_active
                              ? "Branch deactivated (mock)"
                              : "Branch activated (mock)",
                            type: "success",
                          });

                          setBranches((prev) =>
                            prev.map((item) =>
                              item.ROWID === b.ROWID
                                ? { ...item, is_active: !item.is_active }
                                : item
                            )
                          );
                        }}
                        className={`w-full px-4 py-2 text-left text-sm ${b.is_active
                          ? "text-rose-600 hover:bg-rose-50"
                          : "text-purple-600 hover:bg-purple-50"
                          }`}
                      >
                        {b.is_active ? "Deactivate" : "Activate"}
                      </button> */}
                    </Popover>


                  </div>

                  {/* Middle Row: Details */}
                  <div className="mt-3 text-sm text-slate-500 space-y-1">
                    <p>
                      <span className="font-medium text-slate-700">City:</span>{" "}
                      {b.city || "—"}, {b.state || "—"}
                    </p>
                    <p>
                      <span className="font-medium text-slate-700">Country:</span>{" "}
                      {b.country || "—"} · {b.pincode || "—"}
                    </p>
                    <p>
                      <span className="font-medium text-slate-700">Phone:</span>{" "}
                      {b.phone || "—"}
                    </p>
                  </div>

                  {/* Bottom Row: Status */}
                  <div className="mt-3">
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${b.is_active
                        ? "bg-purple-100 text-purple-700"
                        : "bg-rose-100 text-rose-600"
                        }`}
                    >
                      {b.is_active ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>

        </div>
      )}



      {/* ---------- Add Branch Modal ---------- */}
      {isAddOpen && (
        <Modal
          title="Add Branch"
          form={form}
          setForm={setForm}
          onClose={() => setIsAddOpen(false)}
          isAddOpen={isAddOpen}
          onSubmit={async () => {
            try {
              const payload = {
                name: form.Branch_Name,
                address1: form.address1 || "",
                address2: form.address2 || "",
                city: form.city,
                state: form.state,
                country: form.country,
                pincode: form.pincode,
                landmark: form.landmark || "",
                phone: form.phone,
                is_active: form.is_active || true,
              };

              const formData = new FormData();
              formData.append("json", JSON.stringify(payload));

              // Append file correctly
              if (form.image) {
                formData.append("logo", form.image);
              }

              const res = await axios.post(`${apiUrl}createBranch`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  'ZCFKEY': apiKey
                },
              });

              console.log("Branch added response:", res.data);

              if (res.data.branch.code) {
                setToast({ message: "Branch added successfully!", type: "success" });
                setIsAddOpen(false);
                fetchBranch();
              } else {
                setToast({ message: res.data.message || "Failed to add branch", type: "error" });
              }
            } catch (err) {
              console.error(err);
              setToast({ message: "Failed to add branch", type: "error" });
            }
          }}
        />
      )}



      {/* ---------- View Branch Modal ---------- */}
      {isViewOpen && currentBranch && (
        <Modal
          title="View Branch"
          form={currentBranch}
          setForm={() => { }}
          readOnly={true}
          onClose={() => setIsViewOpen(false)}
        />
      )}

      {/* ---------- Edit Branch Modal ---------- */}
      {isEditOpen && currentBranch && (
        <Modal
          title="Edit Branch"
          form={form}
          setForm={setForm}
          onClose={() => setIsEditOpen(false)}
          isEditOpen={isEditOpen}
          onSubmit={async () => {
            try {
              const res = await axios.put(
                `${apiUrl}updateBranchById/${currentBranch.ROWID}`,
                {
                  name: form.Branch_Name,
                  address1: form.address1 || "",
                  address2: form.address2 || "",
                  city: form.city,
                  state: form.state,
                  country: form.country,
                  pincode: form.pincode,
                  landmark: form.landmark || "",
                  is_active: form.is_active,
                  phone: form.phone,
                },
                headers_obj
              );

              if (res.data.success) {
                setToast({ message: res.data.message, type: "success" });
              } else {
                setToast({ message: res.data.message, type: "error" });
              }

              // let updatedLogo = null;

              // ---------- UPLOAD LOGO ----------
              if (form.image) {
                const file = form.image;
                if (file) {
                  const formData = new FormData();
                  formData.append("logo", file);

                  await axios.put(
                    `${apiUrl}updateBranchLogoById/${form.ROWID}`,
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                        'ZCFKEY': apiKey
                      },
                    }
                  );

                  // updatedLogo = ress.data.logo[0]['logo'] || null;
                }
              }

              fetchBranch();
              setIsEditOpen(false);

            } catch (err) {
              console.error(err);
              setToast({ message: "Failed to update branch", type: "error" });
            }
          }}


        />
      )}
    </>
  );
}

function Modal({ title, form, setForm, onClose, onSubmit, readOnly, isAddOpen, isEditOpen }) {

  const [errors, setErrors] = useState({});

  const stateOptions = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
    "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
  ];

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const logo = URL.createObjectURL(file); // preview
      setForm(prev => ({ ...prev, image: file, logo: logo }));
      setErrors(prev => ({ ...prev, image: null }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!form.Branch_Name?.trim()) newErrors.Branch_Name = "Branch name is required";
    if (!form.phone?.trim()) newErrors.phone = "Phone number is required";
    if (!form.city?.trim()) newErrors.city = "City is required";
    if (!form.state?.trim()) newErrors.state = "State is required";
    if (!form.country?.trim()) newErrors.country = "Country is required";
    if (!form.address1?.trim()) newErrors.address1 = "Address is required";
    if (!form.pincode?.trim()) newErrors.pincode = "Pincode is required";

    // Phone format
    const phoneRegex = /^[0-9]{10,15}$/;
    if (form.phone && !phoneRegex.test(form.phone)) {
      newErrors.phone = "Phone must be 10–15 digits";
    }

    // Pincode format
    const pinRegex = /^[0-9]{4,10}$/;
    if (form.pincode && !pinRegex.test(form.pincode)) {
      newErrors.pincode = "Pincode must be 4–10 digits";
    }

    // Image validation
    if (form.image && typeof form.image !== "string") {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
      if (!allowedTypes.includes(form.image.type)) {
        newErrors.image = "Only JPG, PNG, WEBP images allowed";
      }

      const maxSize = 2 * 1024 * 1024;
      if (form.image.size > maxSize) {
        newErrors.image = "Image size must be less than 2MB";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh] animate-slideUp">

        {/* Header */}
        <div className="px-8 py-6 border-b border-slate-100 flex justify-between items-center bg-white sticky top-0 z-10">
          <div>
            <h2 className="text-xl font-bold text-slate-800">{title}</h2>
            <p className="text-xs text-slate-400 mt-0.5">Please provide branch details below</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-8 overflow-y-auto custom-scrollbar bg-white">

          {/* Image Upload */}
          {(isAddOpen || isEditOpen) && (
            <div className="mb-8 flex flex-col items-center sm:flex-row gap-6 p-5 rounded-2xl bg-slate-50 border border-dashed border-slate-200">
              <div className="relative group">
                <div className="h-24 w-24 rounded-2xl overflow-hidden bg-slate-200 ring-4 ring-white shadow-md">
                  {form.logo ? (
                    <img src={form.logo} alt="Preview" className="h-full w-full object-cover" />
                  ) : (
                    <div className="h-full w-full flex items-center justify-center text-slate-400 text-xs text-center p-2 font-medium">
                      No Logo
                    </div>
                  )}
                </div>
              </div>
              <div className="flex-1 text-center sm:text-left">
                <h4 className="text-sm font-bold text-slate-700">Branch Identity</h4>
                <p className="text-xs text-slate-500 mb-3">Upload a high-quality logo (PNG, JPG)</p>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="hidden"
                  id="logo-upload"
                />
                <label
                  htmlFor="logo-upload"
                  className="inline-block px-4 py-2 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-600 cursor-pointer hover:border-purple-500 hover:text-purple-600 transition-all shadow-sm"
                >
                  Choose Image
                </label>

                {errors.image && (
                  <div className="text-[11px] text-rose-500 mt-2 font-medium">
                    {errors.image}
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="space-y-8">

            {/* Basic Info */}
            <div>
              <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5">Basic Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <FormInput
                  label="Branch Name"
                  value={form.Branch_Name}
                  onChange={(val) => {
                    setForm(p => ({ ...p, Branch_Name: val }));
                    setErrors(prev => ({ ...prev, Branch_Name: null }));
                  }}
                  placeholder="e.g. Headquarters"
                  readOnly={readOnly}
                  error={errors.Branch_Name}
                />

                <FormInput
                  label="Phone Number"
                  value={form.phone}
                  onChange={(val) => {
                    setForm(p => ({ ...p, phone: val }));
                    setErrors(prev => ({ ...prev, phone: null }));
                  }}
                  placeholder="+91 00000 00000"
                  readOnly={readOnly}
                  error={errors.phone}
                />
              </div>
            </div>

            {/* Address */}
            <div>
              <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5">Location Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

                <FormInput
                  label="Address Line 1"
                  value={form.address1}
                  onChange={(val) => {
                    setForm(p => ({ ...p, address1: val }));
                    setErrors(prev => ({ ...prev, address1: null }));
                  }}
                  placeholder="Street, Building No."
                  readOnly={readOnly}
                  error={errors.address1}
                />

                <FormInput
                  label="Address Line 2"
                  value={form.address2}
                  onChange={(val) => setForm(p => ({ ...p, address2: val }))}
                  placeholder="Street, Building No."
                  readOnly={readOnly}
                />

                <FormInput
                  label="Landmark"
                  value={form.landmark}
                  onChange={(val) => setForm(p => ({ ...p, landmark: val }))}
                  placeholder="Landmark"
                  readOnly={readOnly}
                />

                <FormInput
                  label="City"
                  value={form.city}
                  onChange={(val) => {
                    setForm(p => ({ ...p, city: val }));
                    setErrors(prev => ({ ...prev, city: null }));
                  }}
                  placeholder="City"
                  readOnly={readOnly}
                  error={errors.city}
                />

                {/* State */}
                <div className="flex flex-col">
                  <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1">State</label>
                  <div className="relative group">
                    <select
                      disabled={readOnly}
                      value={form.state || ""}
                      onChange={(e) => {
                        setForm(prev => ({ ...prev, state: e.target.value }));
                        setErrors(prev => ({ ...prev, state: null }));
                      }}
                      className={`
                        w-full appearance-none bg-white border rounded-xl px-4 py-2.5 text-sm transition-all outline-none cursor-pointer
                        ${errors.state ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
                        ${readOnly ? 'bg-slate-50 text-slate-400 cursor-not-allowed' : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
                      `}
                    >
                      <option value="" disabled>Select State</option>
                      {stateOptions.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </div>

                  {errors.state && (
                    <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium">
                      {errors.state}
                    </span>
                  )}
                </div>

                <FormInput
                  label="Pincode"
                  value={form.pincode}
                  onChange={(val) => {
                    setForm(p => ({ ...p, pincode: val }));
                    setErrors(prev => ({ ...prev, pincode: null }));
                  }}
                  placeholder="6-digit code"
                  readOnly={readOnly}
                  error={errors.pincode}
                />

                <FormInput
                  label="Country"
                  value={form.country}
                  onChange={(val) => {
                    setForm(p => ({ ...p, country: val }));
                    setErrors(prev => ({ ...prev, country: null }));
                  }}
                  placeholder="Enter country"
                  readOnly={readOnly}
                  error={errors.country}
                />
              </div>
            </div>

            {/* Status Toggle */}
            {!readOnly && (
              <div className="flex items-center justify-between p-5 rounded-2xl bg-slate-50 border border-slate-100 transition-all hover:bg-slate-100/50">
                <div>
                  <p className="text-sm font-bold text-slate-700">Active Status</p>
                  <p className="text-xs text-slate-500">Visible to customers and staff</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={form.is_active}
                    onChange={(e) => setForm(p => ({ ...p, is_active: e.target.checked }))}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                </label>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-8 py-6 border-t border-slate-100 bg-white flex flex-col sm:flex-row justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 hover:text-slate-700 transition-colors"
          >
            Discard
          </button>

          {!readOnly && (
            <button
              onClick={() => {
                if (validateForm()) {
                  onSubmit();
                }
              }}
              className="px-8 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-bold hover:bg-purple-600 transition-all shadow-lg shadow-slate-200 active:scale-95"
            >
              {isAddOpen ? "Create Branch" : "Save Changes"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function FormInput({ label, value, onChange, placeholder, readOnly, type = "text", error }) {
  return (
    <div className="flex flex-col">
      <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1">{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ""}
        readOnly={readOnly}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
          ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
          ${readOnly ? 'bg-slate-50 text-slate-400 cursor-not-allowed' : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
        `}
      />

      {error && (
        <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium">
          {error}
        </span>
      )}
    </div>
  );
}
